import Card from '@/components/Card';
import { FormField } from '@/components/Form/FormField';
import { FieldValues } from 'react-hook-form';
import { FormManagementProps } from '@/type/form.types';
import { FormFieldReportSection } from '@/components/Form/FormFieldReportSection';
import { TitleSection } from '@/components/Header/Section/TitleSection';

export const VehiculeCheckViewClient = <TSchema extends FieldValues>({
  t,
  data,
}: FormManagementProps<TSchema>) => {
  return (
    <Card
      title={<TitleSection text="Client" defaultIconClassName="ki-user" />}
      bodyClassName="py-8 flex flex-col gap-5"
    >
      <>
        <FormFieldReportSection>
          <FormField
            text={`${t('common:lastname')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm text-black">{data?.individualLastname}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:firstname')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualFirstname}</p>
            </div>
          </FormField>
        </FormFieldReportSection>
        <FormFieldReportSection>
          <FormField
            text={`${t('common:email')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualEmail || '--'}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:phoneNumber')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualPhone || '--'}</p>
            </div>
          </FormField>
        </FormFieldReportSection>
        <FormFieldReportSection>
          <FormField
            text={`${t('common:addressLine1_with_parenthesis')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualAddressLine1 || '--'}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:addressLine2_with_parenthesis')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualAddressLine2 || '--'}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:postalCode')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualPostalCode || '--'}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:city')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualCity || '--'}</p>
            </div>
          </FormField>
          <FormField
            text={`${t('common:country')} :`}
            textClassName="font-semibold text-slate-500"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <p className="text-sm">{data?.individualCountry || '--'}</p>
            </div>
          </FormField>
        </FormFieldReportSection>
      </>
    </Card>
  );
};
